<template>
  <div>
    <b-container>
      <transition name="fade">
        <ProductsList scope="eb" :total="getTotal" :selected-product-data="getProduct" :selected-product-docs="getDocs" :products="getProducts" :title="$t('text.productsEB.title')" :text="$t('text.productsEB.text')" @on-product-select="showProduct(...arguments)" @on-click-load-more="loadMore">
          <template #ingress>
            <h2 class="d-print-none">{{ products_elslutbleck_title }}</h2>
            <p class="d-print-none">{{ products_elslutbleck_text }}</p>
          </template>
        </ProductsList>
      </transition>
    </b-container>
  </div>
</template>

<script>
  import store from "@/store/store";
  import { mapGetters, mapActions } from "vuex";
  import productsListMixin from "@/mixins/productsListMixin";
  import contentMixin from "@/mixins/contentMixin";
  export default {
    name: "ProductsListViewEB",
    mixins: [productsListMixin, contentMixin],
    computed: {
      ...mapGetters("productsEB", ["getProducts", "getCount", "getTotal"]),
      ...mapGetters("productEB", ["getProduct", "getDocs"]),
    },
    methods: {
      ...mapActions("productsEB", ["fetchProducts"]),
      ...mapActions("productEB", ["fetchProduct", "fetchDocsForArt"]),
      loadMore() {
        this.$store.dispatch("productsEB/updateSkip");
      },
    },
    beforeRouteEnter(to, from, next) {
      // Reset pagination
      store.dispatch("productsEB/resetSkip");
      // Reset selected product
      store.dispatch("productEB/resetProduct");
      store
        .dispatch("productsEB/fetchProducts")
        .then(() => next())
        .catch((error) => {
          if (error.response && error.response.status == 404) {
            next({ name: "404", params: { resource: "event" } });
          } else {
            next({ name: "network-issue" });
          }
        });
    },
    beforeRouteUpdate(to, from, next) {
      store.dispatch("productsEB/fetchProducts").then(() => {
        next();
      });
    },
  };
</script>

<style lang="scss" scoped></style>
